export const TEMPLATE_LIST = [
  'store',
  'centre',
  'news',
  'topic',
  'story',
  'offer',
  'service',
  'event',
  'movie',
  'whats-happening',
  'opening-hours',
]

export default TEMPLATE_LIST.reduce((acc, template) => {
  acc[template] = template

  return acc
}, {})
